import { render, staticRenderFns } from "./MicrosoftIcon.vue?vue&type=template&id=459ef890&scoped=true"
import script from "./MicrosoftIcon.vue?vue&type=script&lang=js"
export * from "./MicrosoftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ef890",
  null
  
)

export default component.exports